var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sectioned-list',{attrs:{"sections":_vm.categories,"sectionKey":"key","sectionTitle":"key","sectionItems":"value","itemKey":"name","itemTitle":"name"},on:{"item-clicked":_vm.navigate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }